/**
 * Truncates a string to a specified maximum length
 * @param {string} str - The string to truncate
 * @param {number} maxLength - The maximum length of the string (default: 50)
 * @param {string} ellipsis - The ellipsis to append to the string (default: '...')
 * @returns {string} The truncated string with ellipsis appended if the string was truncated
 */
export const truncateString = (str: string, maxLength = 50, ellipsis = '...'): string => {
  if (str.length <= maxLength) {
    return str;
  }
  return `${str.slice(0, maxLength)}${ellipsis}`;
};
